
import React, { useRef, useEffect } from "react";
import { MessageCircle } from "lucide-react";
import { cn } from "@/lib/utils";
import ChatMessage from "./ChatMessage";
import { Message } from "./useChatMessages";

interface ChatMessageListProps {
  messages: Message[];
  isMinimized: boolean;
}

const ChatMessageList: React.FC<ChatMessageListProps> = ({
  messages,
  isMinimized,
}) => {
  const messagesEndRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (messagesEndRef.current) {
      messagesEndRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [messages]);

  return (
    <div 
      className={cn(
        "flex-1 overflow-y-auto p-3 space-y-4 transition-all",
        isMinimized ? "hidden" : "block"
      )}
    >
      {messages.length === 0 ? (
        <div className="text-center text-gray-500 dark:text-gray-400 py-8">
          <MessageCircle className="mx-auto mb-2 h-8 w-8 opacity-50" />
          <p>Ask me questions about estimation!</p>
          <p className="text-xs mt-2">Examples:</p>
          <ul className="text-xs mt-1 space-y-1">
            <li>• How many pages could I build in 20 days?</li>
            <li>• What's a good estimate for a complex workflow?</li>
            <li>• How should I estimate a data migration?</li>
          </ul>
        </div>
      ) : (
        messages.map((msg, index) => (
          <ChatMessage key={index} message={msg} />
        ))
      )}
      <div ref={messagesEndRef} />
    </div>
  );
};

export default ChatMessageList;
